// =============================================================================
// GenieTypingIndicator.jsx
// -----------------------------------------------------------------------------
// Reusable, accessible chat typing placeholder. Render this while an assistant
// response is intentionally delayed or being generated.
// =============================================================================

import React from "react";

const GenieTypingIndicator = () => (
  <div
    className="flex justify-start"
    role="status"
    aria-label="Genie is typing"
  >
    {/* Three staggered dots create a familiar assistant-typing animation. */}
    <div className="flex items-center gap-1 bg-[#412293] px-4 py-3 rounded-2xl rounded-tl-none shadow-md">
      {[0, 1, 2].map((dot) => (
        <span
          key={dot}
          className="h-2 w-2 animate-bounce rounded-full bg-white"
          style={{ animationDelay: `${dot * 150}ms` }}
        />
      ))}
    </div>
  </div>
);

export default GenieTypingIndicator;